import React from 'react'
import CodeEditor from './CodeEditor'
import InfoPanel from './InfoPanel'
import ResultPanel from './ResultPanel'
import './App.css'

class App extends React.Component {
  render () {
    return (
      <div className="App">
        <CodeEditor />
        <ResultPanel />
        <InfoPanel />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js